import { withNamespaces } from "react-i18next";
import MessageBox from "src/modules/data-protection/components/MessageBox";
import { Label } from "reactstrap";
import { useMemo } from "react";

const Messages = ({
    t,
    caseId,
    isLoading,
    isReportDeleted = false
}) => {
    const messageSettings = useMemo(() => {
        return {
            headerOptions: {
                displayFilters: true,
                title: 'Messages',
                tooltipText: 'Note: This message will be visible to the assigned analyst.'
            },
            messageListUrl: "report.listComment",
            sendMessageUrl: "report.addComment",
            attachmentDownloadUrl: "/report/attachment/{attachmentId}/download",
            attachmentUploadUrl: "report.uploadAttachment",
            attachmentDeleteUrl: "attachment/",
            payloadId: "report_case_id",
            assetId: caseId,
            mention: {
                enable: false,
                suggestionList: []
            }
        }
    }, []);

    if (isLoading) {
        return (
            <div className="dt-field dt-skeleton" style={{ width: "100%", height: "320px" }}></div>
        );
    }

    if (isReportDeleted) {
        return (
            <Label className="text-danger d-flex justify-content-center">
                {t("The case has been deleted.")}
            </Label>
        );
    }

    return (
        <MessageBox
            settings={messageSettings}
        />
    );
};

export default withNamespaces()(Messages);
